import { render, staticRenderFns } from "./SquareBackground.vue?vue&type=template&id=4dc88844&scoped=true"
import script from "./SquareBackground.vue?vue&type=script&lang=js"
export * from "./SquareBackground.vue?vue&type=script&lang=js"
import style0 from "./SquareBackground.vue?vue&type=style&index=0&id=4dc88844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc88844",
  null
  
)

export default component.exports